import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class MmuWebComponentBase implements OnInit, OnDestroy {

  /**
   * Set the language of the WebComponent.
   * WARNING: When used as an Angular component, it will override the language of the whole application. Use with caution!
   *
   * @param lang: The language that should be used.
   */
  @Input()
  set lang(lang: string) {
    if (this._translate) {
      this._translate.use(lang);
    }
  }

  protected destroy$ = new Subject<void>();

  protected abstract translations: { [lang: string]: Record<string, unknown> };

  protected constructor(protected _translate: TranslateService) {}

  ngOnInit(): void {
    this.upgradeTranslations();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private upgradeTranslations() {
    // Make sure at least one language is merged, even if currentLang is not set yet
    this.mergeTranslationsForLang(this._translate.currentLang || this._translate.defaultLang);

    this._translate.onLangChange.subscribe(e => {
      // Merge new translations on the fly when the language is changed
      this.mergeTranslationsForLang(e.lang);
    });
  }

  private mergeTranslationsForLang(lang: string) {
    if (this.translations[lang]) {
      this._translate.setTranslation(lang, this.translations[lang], true);
    }
  }

}
